export type SecretPayload = {
  secret: string;
  message: string;
};

export function buildSecretPayload(secret: string, message: string): string {
  return JSON.stringify({
    secret,
    message,
  });
}

function isSecretPayload(value: unknown): value is SecretPayload {
  if (value === null || typeof value !== "object" || Array.isArray(value)) {
    return false;
  }

  const record = value as Record<string, unknown>;
  return typeof record.secret === "string" && typeof record.message === "string";
}

// Links created before the JSON payload stored the secret itself.
// Those documents stay readable until their existing expiration.
export function parseSecretPayload(plain: string): SecretPayload {
  try {
    const parsed: unknown = JSON.parse(plain);
    if (isSecretPayload(parsed)) {
      return {
        secret: parsed.secret,
        message: parsed.message,
      };
    }
  } catch {
    // Not JSON: this is a legacy plaintext secret.
  }

  return { secret: plain, message: "" };
}
